var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKohls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 29,
    viewBox: "0 0 187 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_223_546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.708496H12.9125V9.48134H13L22.8396 0.708496H37.3124L25.4349 11.4636L39.1753 26.223H22.8317L12.9841 15.7784H12.8966V26.223H0V0.708496Z",
    fill: "#800033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8353 21.7968C63.5751 21.7968 63.2009 15.3883 63.2009 13.2707C63.2009 11.1531 63.2646 5.28599 57.8353 5.28599C52.4061 5.28599 52.4697 11.1531 52.4697 13.2707C52.4697 15.3883 52.0876 21.7968 57.8353 21.7968ZM57.8353 0C72.4992 0 76.4876 3.07288 76.4876 13.5414C76.4876 24.0099 72.4992 27.0828 57.8353 27.0828C43.1715 27.0828 39.1831 24.0099 39.1831 13.5414C39.1831 3.07288 43.1794 0 57.8353 0Z",
    fill: "#800033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.335 16.6461V26.3981H117.589V0.883667H104.335V9.65651H94.8213V0.883667H81.5586V26.3981H94.8213V16.6461H104.335Z",
    fill: "#800033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.863 0.883667H137.428V20.324C137.428 20.324 148.255 20.3559 149.696 20.3559C151.137 20.3559 151.988 19.0662 151.988 19.0662V26.3981H123.871V0.883667H123.863Z",
    fill: "#800033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.609 9.33004C180.799 7.08509 178.395 6.32881 175.815 6.289C173.292 6.24124 170.975 7.12489 170.975 8.66133C170.975 9.87934 172.703 10.3809 178.737 11.6387C183.696 12.6736 187 15.2131 187 19.9259C187 25.2517 178.148 28.2609 170.219 28.2609C164.654 28.2609 160.387 27.2578 156.566 25.5463V18.3974C158.93 20.8573 164.208 22.1709 168.26 22.1709C170.505 22.1709 171.612 21.8445 171.612 20.0533C171.612 18.9467 170.211 17.9357 165.976 17.1635C157.943 15.6907 155.229 13.3901 155.229 9.46537C155.229 3.82114 162.25 0.46167 170.895 0.46167C175.56 0.46167 179.843 0.604965 183.609 2.35635V9.338V9.33004Z",
    fill: "#800033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.425 11.2884L145.357 9.64848C142.562 8.2633 141.734 4.75257 143.159 2.74644C144.688 0.589052 148.923 -0.334405 151.216 3.00118C153.166 5.85116 151.303 8.2633 150.452 8.95589C149.608 9.64848 144.433 11.2884 144.433 11.2884",
    fill: "#800033"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_223_546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 28.261,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKohls);
export default __webpack_public_path__ + "static/media/Kohls.142d907ea70ac20ff513e829a2abe6a9.svg";
export { ForwardRef as ReactComponent };